import { DestroyRef, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class PendingChangesGuard {
  private readonly before_unload_checks = new Set<() => boolean>();

  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', this.handleBeforeUnload);
    }
  }

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    const result = component.canDeactivate();

    if (typeof result === 'boolean') {
      return this.confirmBrowserNavigationIfNeeded(result);
    }

    return result.pipe(map(can_deactivate => this.confirmBrowserNavigationIfNeeded(can_deactivate)));
  }

  registerBeforeUnload(component: ComponentCanDeactivate, destroy_ref: DestroyRef): void {
    const check = (): boolean => {
      const result = component.canDeactivate();

      return typeof result === 'boolean' ? result : true;
    };

    this.before_unload_checks.add(check);
    destroy_ref.onDestroy((): void => {
      this.before_unload_checks.delete(check);
    });
  }

  private readonly handleBeforeUnload = (event: BeforeUnloadEvent): void => {
    const can_unload = [...this.before_unload_checks].every(check => check());

    if (can_unload) {
      return;
    }

    event.preventDefault();
  };

  private confirmBrowserNavigationIfNeeded(can_deactivate: boolean): boolean {
    if (can_deactivate || typeof window === 'undefined') {
      return true;
    }

    return window.confirm('Hay cambios pendientes. Si continúas, se perderán.');
  }
}
